import VueSingleSelect from "vue-single-select";

import { VMoney } from 'v-money'
import { axiosRequest } from '../../utils/Requests.js';
import { getReais, getCentavos, getNumeroSemFormatacao } from '../../utils/Utils.js'

export default {
  components: { 
    VueSingleSelect
  },
  directives: { money: VMoney },
  props: [ 'rota', 'imobiliaria', 'parametros' ],
  data() {
    return {
      titulo: "",
      loadingImoveis: true,
      tabAtiva: '',
      quantidade: 0,
      imoveis: [],
      pagina: 0,
      totalPaginas: 0,
      cidadeBairro: undefined,
      keyValorMinimo: 0,
      keyValorMaximo: 0,
      valorMinimo: undefined,
      valorMaximo: undefined,

      valorOrder: 'asc',

      params: {
        operacao: undefined,
        bairro: undefined,
        cidade: undefined,
        valorMinimo: undefined,
        valorMaximo: undefined,
        tipoImovel: undefined,
        quartos: undefined,
        area: undefined
      },

      moneyMask: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: false
      }
    }
  },
  computed: {
    somenteAluguel() { return this.imobiliaria.aluguel && !this.imobiliaria.venda },
    somenteVenda() { return this.imobiliaria.venda && !this.imobiliaria.aluguel },
    ambos() { return this.imobiliaria.venda && this.imobiliaria.aluguel },

    listaCidadesBairros() {
      let array = this.imobiliaria.cidades.map((cidade) => { return { nome: cidade.nome, id: cidade.id } })
      array = array.concat(this.imobiliaria.bairros.map((bairro) => { return { nome: bairro.nome + ' (' + bairro.cidade.nome + ')', id: bairro.cidade.id + "-" + bairro.id } }))
      return array
    },
    textoQuantidade() {
      if(this.loadingImoveis) { return "Carregando imóveis" }
      if(this.quantidade == 0) { return "Nenhum imóvel encontrado" }
      if(this.quantidade == 1) { return "1 imóvel para " + this.$route.params.operacao }
      
      return this.quantidade + " imóveis para " + this.$route.params.operacao
    },
    exibirPaginacao() { return this.totalPaginas >= 1 },

    desabilitarBotaoPaginaAnterior() { return this.pagina == 0 || this.loadingImoveis },
    desabilitarBotaoProximaPagina() { return this.pagina == this.totalPaginas || this.loadingImoveis }
  },
  watch: {
    'valorMinimo'(newValue) {
      if(newValue == "0" || newValue == "0,0" || newValue == "0,00" ) {
        this.valorMinimo = undefined
        this.params.valorMinimo = undefined
        this.keyValorMinimo++
        this.$nextTick(() => this.$refs.valorMinimoInput.focus())
      } else {
        this.params.valorMinimo = (parseFloat(getNumeroSemFormatacao(newValue)) ? parseFloat(getNumeroSemFormatacao(newValue)) : undefined)
      }
    },
    'valorMaximo'(newValue) {
      if(newValue == "0" || newValue == "0,0" || newValue == "0,00" ) {
        this.valorMaximo = undefined
        this.params.valorMaximo = undefined
        this.keyValorMaximo++
        this.$nextTick(() => this.$refs.valorMaximoInput.focus())
      } else {
        this.params.valorMaximo = (parseFloat(getNumeroSemFormatacao(newValue)) ? parseFloat(getNumeroSemFormatacao(newValue)) : undefined)
      }
    },
    cidadeBairro() {
      if(!this.cidadeBairro) {
        this.params.cidade = undefined
        this.params.bairro = undefined
        return
      }

      let array = this.cidadeBairro.id.toString().split("-")
      this.params.cidade = (array[0] ? array[0] : undefined)
      this.params.bairro = (array[1] ? array[1] : undefined)
    },
    titulo() {
      document.title = this.titulo + " | " + this.imobiliaria.nome
    },
    '$route' (to) {
      this.tabAtiva = to.params.operacao
      this.quantidade = 0
      this.pagina = 0
      this.totalPaginas = 0

      this.valorMinimo = undefined
      this.valorMaximo = undefined

      this.params = {
        operacao: undefined,
        bairro: undefined,
        cidade: undefined,
        valorMinimo: undefined,
        valorMaximo: undefined,
        tipoImovel: undefined,
        quartos: undefined,
        area: undefined
      }

      this.setarParametrosURL()
      this.listarImoveis()
      this.montarTitulo()
    },
  },
  created() {
    this.setarParametrosURL()
    this.listarImoveis()
    this.montarTitulo()
  },
  methods: {
    getReais,
    getCentavos,
    getNumeroSemFormatacao,
    setData(resultado) {
      this.tabAtiva = this.$route.params.operacao
      
      this.imoveis = resultado.lista
      this.quantidade = resultado.quantidade
      this.totalPaginas = resultado.totalPaginas
      
      this.loading = false;
      this.loadingImoveis = false;
    },
    pesquisar() {
      this.params.operacao = (this.tabAtiva == "alugar" ? "ALUGUEL" : "VENDA")
      this.pagina = 0;

      this.$router.push(this.montarURL())
      this.listarImoveis()
      this.montarTitulo()
    },

    proximaPagina() {
      if(this.pagina < this.totalPaginas) { this.pagina += 1 }
      this.$router.push({ path: this.$route.path, query: { ...this.$route.query, pagina: this.pagina } })
      this.listarImoveis()
    },
    paginaAnterior() {
      if(this.pagina > 0) { this.pagina -= 1 }
      this.$router.push({ path: this.$route.path, query: { ...this.$route.query, pagina: this.pagina } })
      this.listarImoveis()
    },
    listarImoveis() {
      this.loadingImoveis = true;

      this.params.sort = this.montarParametroSort();

      axiosRequest.post("/imoveis?pagina=" + this.pagina, this.params)
      .then((resultado) => {
        this.setData(resultado.data)
      }).catch(() => {
        this.pagina += 1
        this.loadingImoveis = false;
      });
    },
    montarURL() {
      return {
        path: this.montarParametroURL(),
        query: { 
          pagina: this.pagina,
          valorMinimo: (this.params.valorMinimo ? this.params.valorMinimo : undefined),
          valorMaximo: (this.params.valorMaximo ? this.params.valorMaximo : undefined),
          quartos: (this.params.quartos ? this.params.quartos : undefined),
          area: (this.params.area ? this.params.area : undefined)
        }
      }
    },

    montarParametroSort() {
      const fieldOrderPairs = [
        this.montarParametroSortValor(),
      ];

      const paramValue = fieldOrderPairs.join();

      return paramValue;
    },

    montarParametroSortValor() {
      return this.getFieldOrderPair('valor', this.valorOrder);
    },

    getFieldOrderPair(field, order) {
      const fieldOrderPair = [field, order];

      return fieldOrderPair.join('.');
    },

    montarParametroURL() {
      var texto = "/imoveis/" + this.tabAtiva

      let tipo = this.imobiliaria.tiposImovel.filter( (tipo) => { return tipo.id == this.params.tipoImovel })[0];
      if(tipo) { texto += "/" + tipo.key }

      let cidade = this.imobiliaria.cidades.filter( (cidade) => { return cidade.id == this.params.cidade })[0];
      if(cidade) { texto += "/" + cidade.key }

      let bairro = this.imobiliaria.bairros.filter( (bairro) => { return bairro.id == this.params.bairro })[0];
      if(bairro) { texto += "/" + bairro.key }

      return texto;
    },
    setarParametrosURL() {
      if(this.$route.params.operacao == "alugar") { this.params.operacao = "ALUGUEL"; this.tabAtiva = "alugar" }
      if(this.$route.params.operacao == "comprar") { this.params.operacao = "VENDA"; this.tabAtiva = "comprar" }

      this.setarParametro(this.$route.params.param1)
      this.setarParametro(this.$route.params.param2)
      this.setarParametro(this.$route.params.param3)

      this.setarParametroQuery()

      if(this.params.bairro) {this
        this.cidadeBairro = this.listaCidadesBairros.filter((cidadeBairro) => { return cidadeBairro.id == this.params.cidade + "-" + this.params.bairro })[0]
      } else if(this.params.cidade) {
        this.cidadeBairro = this.listaCidadesBairros.filter((cidadeBairro) => { return cidadeBairro.id == this.params.cidade })[0]
      }
    },
    setarParametro(parametro) {
      if(parametro) {
        let tipo = this.imobiliaria.tiposImovel.filter( (tipo) => { return tipo.key == parametro })[0]
        if(tipo) { this.params.tipoImovel = tipo.id; return; }
        
        let cidade = this.imobiliaria.cidades.filter( (cidade) => { return cidade.key == parametro })[0]
        if(cidade) { this.params.cidade = cidade.id; return; }

        let bairro = this.imobiliaria.bairros.filter( (bairro) => { return bairro.key == parametro })[0]
        if(bairro) { this.params.bairro = bairro.id; return; }
      }
    },
    setarParametroQuery() {
      let query = this.$route.query 

      if(parseInt(query.pagina)) { this.pagina = parseInt(query.pagina) } else { this.pagina = 0 }
      if(query.valorMinimo) { this.valorMinimo = parseFloat(query.valorMinimo).toFixed(2) }
      if(query.valorMaximo) { this.valorMaximo = parseFloat(query.valorMaximo).toFixed(2) }
      if(query.quartos) { this.params.quartos = query.quartos }
      if(query.area) { this.params.area = query.area }
    },
    montarTitulo() {
      let texto = ""
      let tipo = this.imobiliaria.tiposImovel.filter((tipo) => { return tipo.id == this.params.tipoImovel })[0]
      let bairro = this.imobiliaria.bairros.filter((bairro) => { return bairro.id == this.params.bairro })[0]
      let cidade = this.imobiliaria.cidades.filter((cidade) => { return cidade.id == this.params.cidade })[0]

      texto += (tipo ? tipo.plural : "Imóveis") + " para " + this.tabAtiva
      if(bairro) {
        texto += " - " + bairro.nome + ", " + bairro.cidade.nome
      } else {
        texto += (cidade ? " em " + cidade.nome : "")
      }
      
      this.titulo = texto
    }
  }
}
